<template>
  <div class="cc" v-wechat-title="$store.state.region.re_name +'-云推介'">
    <div id="gyroContain" @click.stop="isShow">
      <div class="huiyi">
        <div class="ppt">
          <div class="boxitem" v-for="item in list.total_img" :key="item.id">
            <img :src="item.img_urls" alt="" />
          </div>
        </div>
        <div class="videoView">
          <video
            class="videos"
            :src="list.cloudpro_video"
            width="100%"
            height="200"
          ></video>
        </div>
      </div>
      <div class="back" :class="isTop ? 'activeds' : ''">
        <img @click="back" src="@/assets/images/back_bai.png" alt="" />
        <p>{{ list.cloudpro_name }}</p>
      </div>
      <!-- 字幕 -->
      <!-- <div class="zimu">
        <p>觉醒的年代，为中华崛起之奋斗</p>
      </div> -->
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { cloudpromotiondetail } from "@/api/travel";
export default {
  data() {
    return {
      list: {},
      timer: null,
      timer1: null,
      num: -1,
      isEmelents: [],
      isTop: false,
      isArr: [],
    };
  },
  methods: {
    isEmelent() {
      let flag = true;
      let that = this;
      // 获取所有视频元素
      this.timer = setInterval(() => {
        if (this.list.total_img && this.list.total_img.length > 0 && flag) {
          flag = false;
          let myVideo = $(".videos");
          myVideo[0].play();
          this.isEmelents = $(".boxitem");
          //使用事件监听方式捕捉事件， 此事件可作为实时监测video 播放状态
          myVideo[0].addEventListener(
            "timeupdate",
            function () {
              var timeDisplay;
              //用秒数来显示当前播放进度
              timeDisplay = Math.floor(myVideo[0].currentTime);
              // console.log(timeDisplay);
              //当视频播放到 4s的时候做处理
              // console.log(that.isArr.indexOf(timeDisplay));
              if (that.isArr.indexOf(timeDisplay) !== -1) {
                //处理代码
                that.isEmelents
                  .eq(that.isArr.indexOf(timeDisplay) + 1)
                  .fadeIn()
                  .siblings()
                  .fadeOut();
              } else if (timeDisplay == 0) {
                that.isEmelents.eq(0).fadeIn().siblings().fadeOut();
              }
            },
            false
          );
          this.setTime();
          clearInterval(this.timer);
        }
      }, 10);
    },
    setTime() {
      // this.timer1 = setInterval(() => {
      //   this.num++;
      //   this.isEmelents.eq(this.num).fadeIn().siblings().fadeOut();
      //   if (this.num >= 2) {
      //     this.num = -1;
      //     // clearInterval(this.timer1);
      //   } else {
      //   }
      // }, 2000);
    },
    // 返回上一页
    back() {
      this.$router.back();
    },
    isShow() {
      this.isTop = !this.isTop;
    },
  },
  mounted() {
    this.isEmelent();
  },
  //页面销毁
  beforeCreate() {
    //清楚定时器
    clearInterval(this.timer);
    clearInterval(this.timer1);
  },
  created() {
    cloudpromotiondetail(this.$route.params).then((res) => {
      console.log(res);
      this.list = res.find_cloudprolist;
      res.find_cloudprolist.total_img.map((v) => {
        this.isArr.push(v.cloudpro_time);
      });
    });
    this.$toast("请横屏观看");
  },
};
</script>
<style>
</style>
<style scoped>
@media screen and (orientation: portrait) {
  html {
    width: 100vmin;
    height: 100vmax;
  }
  body {
    width: 100vmin;
    height: 100vmax;
  }
  #gyroContain {
    width: 100vmax;
    height: 100vmin;
    transform-origin: top left;
    transform: rotate(90deg) translate(0, -100vmin);
  }
}
@media screen and (orientation: landscape) {
  html {
    width: 100vmax;
    height: 100vmin;
  }
  body {
    width: 100vmax;
    height: 100vmin;
  }
  #gyroContain {
    width: 100vmax;
    height: 100vmin;
  }
}
.cc {
  background: url("../../assets/images/0000.jpg") center no-repeat;
  background-size:100% 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100vh;
}
.ppt {
  flex: 2.8;
  overflow: hidden;
  position: relative;
  border-left: 4px solid #fff;
  border-top: 4px solid #fff;
  border-bottom: 4px solid #fff;
}
.boxitem {
  position: absolute;
  display: none;
  width: 100%;
  height: 100%;
}
.boxitem:first-child {
  display: block;
}
.videoView {
  flex: 1;
  border-left: 4px solid #fff;
  border-right: 4px solid #fff;
  border-top: 4px solid #fff;
  border-bottom: 4px solid #fff;
  overflow: hidden;
}
.videoView video {
  height: 100vw;
  display: block;
  object-fit: cover;
}
.ppt img {
  width: 100%;
  height: 100%;
  display: block;
}

.huiyi {
  padding: 40px;
  display: flex;
  justify-content: space-between;
  height: 96%;
  padding-bottom: 0;
  overflow: hidden;
}
.back {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.5);
  line-height: 36px;
  padding: 0 10px;
  color: #fff;
  transition: 0.3s;
}
.back img {
  width: 28px;
  height: 26px;
  margin-right: 20px;
}
.activeds {
  transform: translateY(-100%);
  transition: 0.3s;
}
.zimu {
  height: 10%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #000;
}
</style>